import React, { useState, useEffect } from 'react';
import {
  Flex,
  Text,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react';

const FrequencyCap = ({ context = '', setFieldValue, frequency_control_specs }) => {
  const defaultMax = frequency_control_specs?.find(spec => 'max_frequency' in spec)?.max_frequency ?? 1;
  const defaultInterval = frequency_control_specs?.find(spec => 'interval_days' in spec)?.interval_days ?? 7;

  const [maxFrequency, setMaxFrequency] = useState(defaultMax.toString());
  const [intervalDays, setIntervalDays] = useState(defaultInterval.toString());

  useEffect(() => {
    setMaxFrequency(defaultMax.toString());
    setIntervalDays(defaultInterval.toString());
  }, [defaultMax, defaultInterval]);

  const updateSpecs = (field, value) => {
    const updatedSpecs = [...frequency_control_specs];
    let updated = false;

    for (let i = 0; i < updatedSpecs.length; i++) {
      if (field in updatedSpecs[i]) {
        updatedSpecs[i] = { ...updatedSpecs[i], [field]: value };
        updated = true;
        break;
      }
    }

    if (!updated) {
      updatedSpecs.push({ [field]: value });
    }

    setFieldValue('frequency_control_specs', updatedSpecs);
  };

  const handleMaxChange = (valueStr, valueNum) => {
    setMaxFrequency(valueStr);
    if (valueStr !== '') updateSpecs('max_frequency', valueNum);
  };

  const handleIntervalChange = (valueStr, valueNum) => {
    setIntervalDays(valueStr);
    if (valueStr !== '') updateSpecs('interval_days', valueNum);
  };

  const handleMaxBlur = () => {
    let value = parseInt(maxFrequency);
    if (isNaN(value) || value < 1) value = defaultMax;
    if (value > 90) value = 90;
  
    setMaxFrequency(value.toString());
    updateSpecs('max_frequency', value);
  };
  
  const handleIntervalBlur = () => {
    let value = parseInt(intervalDays);
    if (isNaN(value) || value < 1) value = defaultInterval;
    if (value > 90) value = 90;
  
    setIntervalDays(value.toString());
    updateSpecs('interval_days', value);
  };
  

  return (
    <Flex align="center" gap={2}>
      <NumberInput
        value={maxFrequency}
        min={1}
        max={90}
        size="sm"
        onChange={handleMaxChange}
        onBlur={handleMaxBlur}
        width="90px"
        clampValueOnBlur={false}
        isDisabled={context === 'adsetEdit'}
      >
        <NumberInputField borderRadius="md" />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>

      <Text fontSize="14px">impression every</Text>

      <NumberInput
        value={intervalDays}
        min={1}
        max={90}
        size="sm"
        onChange={handleIntervalChange}
        onBlur={handleIntervalBlur}
        width="90px"
        clampValueOnBlur={false}
        isDisabled={context === 'adsetEdit'}
      >
        <NumberInputField borderRadius="md" />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>

      <Text fontSize="14px">days</Text>
    </Flex>
  );
};

export default FrequencyCap;
